import React from 'react';
import '../styles/style.css'
import producthuntlogo from '../assets/product-hunt-logo.jpg'
import logo from '../assets/brand-logo.jpg'

export class SiteHeader extends React.Component {
    render () {
        return ((
            <div className="container d-flex mb-3 py-3">
                <img src={producthuntlogo} alt="product-hunt-logo"></img>
                <img src={logo} alt="logo"></img>
                <h4 className="px-2 pt-1">Product Hunt Every Day Gems</h4>
            </div>
        ));
    };
};